import { createFileRoute } from "@tanstack/react-router";
import { ClinicalPageShell } from "@/components/clinical";
import { DashboardCard, CrudShellHeader, MERCHANT_HUB_GRID } from "@/components/ds";
import { getMetricasHubLinks } from "@/lib/workspace-hubs";
import { useTenantContext } from "@/lib/tenant-context";
import { MerchantExperienceBar } from "@/components/renata/MerchantExperienceBar";

export const Route = createFileRoute("/app/metricas")({
  component: MetricasHubPage,
  head: () => ({ meta: [{ title: "Métricas — Structura Market" }] }),
});

function MetricasHubPage() {
  const { businessProfile } = useTenantContext();
  const links = getMetricasHubLinks(businessProfile);

  return (
    <div>
      <CrudShellHeader title="Métricas" description="Indicadores y analíticas del negocio" />
      <ClinicalPageShell offset="none" className="pt-6">
        <MerchantExperienceBar screenId="metricas" />
        <div className="mb-4">
          <p className="text-sm font-semibold text-foreground">¿Qué querés revisar?</p>
          <p className="text-xs text-muted-foreground">Elegí una superficie de analytics</p>
        </div>
        <div className={MERCHANT_HUB_GRID} data-tour="workspace-hub">
          {links.map((link) => (
            <DashboardCard
              key={link.id}
              to={link.href}
              search={link.search}
              icon={link.icon}
              title={link.label}
              subtitle={link.description ?? ""}
            />
          ))}
        </div>
      </ClinicalPageShell>
    </div>
  );
}
